// Composeur (accueil et fiches des tenues photographiées) : logo ou nom, tenue, coloris, fil du nom,
// puis commande depuis l'écran (tailles, quantités, ajout au panier) ou demande de maquette par email.
// Le nom, le logo, la photo et l'envoi de la demande sont gérés par adc-garment.js.
(() => {
  const root = document.querySelector('[data-adc-herolive]');
  const G = window.adcGarment;
  if (!root || !G) return;
  root.querySelectorAll('[data-adc-js]').forEach((el) => el.removeAttribute('hidden'));

  const input = root.querySelector('[data-adc-hero-name]');
  const count = root.querySelector('[data-adc-hero-count]');
  const caption = root.querySelector('[data-adc-hero-caption]');
  const fromLink = root.querySelector('[data-adc-hero-fromlink]');
  const placement = root.querySelector('[data-adc-hero-placement]');
  const tenues = Array.from(root.querySelectorAll('[data-adc-hero-tenue]'));
  const sets = Array.from(root.querySelectorAll('[data-adc-hero-set]'));
  const colorBtns = Array.from(root.querySelectorAll('[data-adc-hero-color]'));
  const threadBtns = Array.from(root.querySelectorAll('[data-adc-hero-thread]'));
  const threadStep = root.querySelector('[data-adc-thread-step]');
  const nopreview = root.querySelector('[data-adc-logo-nopreview]');
  const track = (name, data, detail) => { if (typeof window.adcTrack === 'function') window.adcTrack(name, data || {}, detail); };
  let tracked = false;
  // Premier changement de chaque réglage (tenue, coloris, fil), compté une fois par page.
  const changed = {};
  const trackChange = (field) => { if (changed[field]) return; changed[field] = true; track('apercu_modifie', { produit: 'accueil', champ: field }, field); };

  const tenue = () => tenues.find((r) => r.checked) || tenues[0] || null;
  // Coloris proposés pour la tenue choisie (tous si la tenue n'en déclare pas).
  const allowed = () => {
    const t = tenue();
    const list = t && t.dataset.colors ? t.dataset.colors.split('|').filter(Boolean) : [];
    return colorBtns.filter((b) => !list.length || list.includes(b.dataset.adcHeroColor));
  };

  // ---------- Commande depuis l'écran ----------
  // La sélection garde les quantités de chaque tenue et de chaque coloris : 3 pantalons beige puis
  // 3 polaires noires partent ensemble au panier. Elle reste dans le navigateur le temps de la visite.
  const products = {};
  root.querySelectorAll('[data-adc-hero-product]').forEach((el) => {
    try { products[el.dataset.adcHeroProduct] = JSON.parse(el.textContent); } catch (e) {}
  });
  const orderBox = root.querySelector('[data-adc-order]');
  const qtyWrap = root.querySelector('[data-adc-qtys]');
  const sizesFor = root.querySelector('[data-adc-sizes-for]');
  const recap = root.querySelector('[data-adc-recap]');
  const buy = root.querySelector('[data-adc-buy]');
  const totalEl = root.querySelector('[data-adc-total]');
  const orderBtn = root.querySelector('[data-adc-order-submit]');
  const orderLabel = root.querySelector('[data-adc-order-label]');
  const orderErr = root.querySelector('[data-adc-order-error]');
  const maquette = root.querySelector('[data-adc-maquette]');
  const toggle = root.querySelector('[data-adc-maquette-toggle]');
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const orderText = orderLabel ? orderLabel.textContent : '';
  const SEL_KEY = 'adc_selection';
  const loadSel = () => {
    try { const o = JSON.parse(sessionStorage.getItem(SEL_KEY) || '{}'); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; }
  };
  const saveSel = () => { try { sessionStorage.setItem(SEL_KEY, JSON.stringify(sel)); } catch (e) {} };
  let sel = loadSel(); // { "Pantalon||Beige": { "M": 2, "L": 1 } }
  let qty = {};
  let builtFor = '';
  // Après un envoi refusé, la demande de maquette reste ouverte.
  let maquetteOpen = !!root.querySelector('.adc-status--error');
  let busy = false;

  const current = () => {
    const t = tenue();
    if (t && products[t.value]) return products[t.value];
    const keys = Object.keys(products);
    return keys.length ? products[keys[0]] : null;
  };
  const tenueName = () => (tenue() ? tenue().value : (Object.keys(products)[0] || ''));
  const keyOf = (t, c) => `${t}||${c || ''}`;
  const splitKey = (k) => { const i = k.indexOf('||'); return [k.slice(0, i), k.slice(i + 2)]; };
  const currentKey = () => keyOf(tenueName(), G.state.colorName);
  const variantIn = (p, color, size) => p.variants.find((v) => v.size === size && (!v.color || v.color === color));
  const variantFor = (p, size) => variantIn(p, G.state.colorName, size);
  // Lignes de la sélection : tenues commandables, tailles disponibles, quantités supérieures à zéro.
  const selection = () => Object.keys(sel).map((k) => {
    const [t, c] = splitKey(k);
    const p = products[t];
    if (!p || !p.orderable || !sel[k]) return null;
    const lines = p.sizes
      .map((size) => ({ size, v: variantIn(p, c, size), q: Math.max(0, Math.min(999, Number(sel[k][size]) || 0)) }))
      .filter((l) => l.v && l.v.available && l.q > 0);
    return lines.length ? { key: k, tenue: t, color: c, p, lines } : null;
  }).filter(Boolean);

  const buildSizes = (key, p) => {
    if (!qtyWrap || builtFor === key) return;
    builtFor = key;
    qty = sel[key] = sel[key] || {};
    qtyWrap.innerHTML = '';
    p.sizes.forEach((size) => {
      if (qty[size] == null) qty[size] = 0;
      const id = `q-${root.id || 'c'}-${String(size).replace(/\W+/g, '')}`;
      const row = document.createElement('div');
      row.className = 'adc-qty';
      row.dataset.size = size;
      row.innerHTML = `<label class="adc-qty__size" for="${id}"></label><span class="adc-qty__ctrl"><button type="button" class="adc-qty__btn" data-dec>−</button><input class="adc-qty__input" id="${id}" type="number" inputmode="numeric" min="0" max="999" value="0" data-qty><button type="button" class="adc-qty__btn" data-inc>+</button></span>`;
      row.querySelector('label').textContent = size;
      row.querySelector('[data-dec]').setAttribute('aria-label', `Retirer une pièce, taille ${size}`);
      row.querySelector('[data-inc]').setAttribute('aria-label', `Ajouter une pièce, taille ${size}`);
      row.querySelector('[data-qty]').setAttribute('aria-label', `Quantité, taille ${size}`);
      qtyWrap.appendChild(row);
    });
  };

  const renderRecap = (all) => {
    if (!recap) return;
    recap.hidden = !all.length;
    recap.textContent = '';
    if (!all.length) return;
    const title = document.createElement('p');
    title.className = 'adc-label adc-label--ink';
    title.textContent = 'Votre commande';
    const list = document.createElement('ul');
    list.className = 'adc-recap__list';
    const cur = currentKey();
    all.forEach((g) => {
      const li = document.createElement('li');
      li.className = `adc-recap__item${g.key === cur ? ' is-current' : ''}`;
      const name = document.createElement('span');
      name.className = 'adc-recap__name';
      name.textContent = `${g.tenue} · ${g.color.toLowerCase()}`;
      const sizes = document.createElement('span');
      sizes.className = 'adc-recap__sizes';
      sizes.textContent = g.lines.map((l) => `${l.size} × ${l.q}`).join(' · ');
      const actions = document.createElement('span');
      actions.className = 'adc-recap__actions';
      if (g.key !== cur) {
        const edit = document.createElement('button');
        edit.type = 'button';
        edit.className = 'adc-textbtn adc-textbtn--inline';
        edit.dataset.adcRecapEdit = g.key;
        edit.textContent = 'Modifier';
        edit.setAttribute('aria-label', `Modifier ${g.tenue} ${g.color}`);
        actions.appendChild(edit);
      }
      const rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'adc-textbtn adc-textbtn--inline';
      rm.dataset.adcRecapRemove = g.key;
      rm.textContent = 'Retirer';
      rm.setAttribute('aria-label', `Retirer ${g.tenue} ${g.color}`);
      actions.appendChild(rm);
      li.append(name, sizes, actions);
      list.appendChild(li);
    });
    recap.append(title, list);
  };

  const renderOrder = () => {
    const p = current();
    // Sans bloc de commande dans la page (accueil = maquette seulement), rien à commander ici.
    const can = !!(p && p.orderable && orderBox);
    if (orderBox) orderBox.hidden = !can;
    if (buy) buy.hidden = !can;
    if (maquette) maquette.hidden = can && !maquetteOpen;
    // Bouton d'envoi de la maquette masqué : désactivé, pour que la touche Entrée n'envoie pas une demande cachée.
    const mqBtn = maquette && maquette.querySelector('[type="submit"]');
    if (mqBtn) mqBtn.disabled = can && !maquetteOpen;
    if (toggle) toggle.setAttribute('aria-expanded', String(maquetteOpen));
    if (threadStep) threadStep.hidden = !!G.state.logo;
    if (nopreview) nopreview.hidden = !(G.state.logo && !G.state.logo.url);
    if (!can || !qtyWrap) return;
    buildSizes(currentKey(), p);
    if (sizesFor) sizesFor.textContent = ` · ${tenueName()} ${(G.state.colorName || '').toLowerCase()}`;
    qtyWrap.querySelectorAll('.adc-qty').forEach((row) => {
      const size = row.dataset.size;
      const v = variantFor(p, size);
      const ok = !!(v && v.available);
      if (!ok) qty[size] = 0;
      const q = qty[size] || 0;
      row.classList.toggle('is-active', q > 0);
      row.classList.toggle('is-unavailable', !ok);
      const inp = row.querySelector('[data-qty]');
      if (document.activeElement !== inp) inp.value = q;
      inp.disabled = !ok;
      const dec = row.querySelector('[data-dec]');
      const decOff = !ok || q === 0;
      // Le focus ne doit pas tomber dans le vide quand le bouton « − » se désactive sous le doigt ou le clavier.
      if (decOff && ok && document.activeElement === dec) inp.focus();
      dec.disabled = decOff;
      row.querySelector('[data-inc]').disabled = !ok;
    });
    const all = selection();
    let pieces = 0;
    let cents = 0;
    let full = 0;
    // Prix dégressif par modèle : toutes les tailles et tous les coloris d'un même modèle s'additionnent.
    const byModel = {};
    all.forEach((g) => { byModel[g.tenue] = (byModel[g.tenue] || 0) + g.lines.reduce((a, l) => a + l.q, 0); });
    const tierPct = (p0, count) => {
      const t = Array.isArray(p0.tiers) ? p0.tiers : [];
      const base = t.length ? Number(t[0].prix) : 0;
      let best = 0;
      t.forEach((x) => { if (count >= Number(x.min) && base > 0) best = Math.max(best, 1 - Number(x.prix) / base); });
      return best;
    };
    all.forEach((g) => {
      const pct = tierPct(g.p, byModel[g.tenue]);
      g.lines.forEach((l) => { pieces += l.q; full += l.q * l.v.price; cents += Math.round(l.q * l.v.price * (1 - pct)); });
    });
    renderRecap(all);
    if (totalEl) {
      let txt = pieces
        ? `${pieces} pièce${pieces > 1 ? 's' : ''} au total${all.length > 1 ? `, ${all.length} tenues` : ''}${cents > 0 ? ` · ${fmt.format(cents / 100)} HT` : ''}`
        : 'Indiquez les quantités par taille.';
      if (cents > 0 && full > cents) txt += ` (prix dégressif : −${fmt.format((full - cents) / 100)})`;
      // Palier suivant pour la tenue affichée
      const t = Array.isArray(p.tiers) ? p.tiers : [];
      const mine = byModel[tenueName()] || 0;
      const next = t.find((x) => Number(x.min) > mine && Number(x.min) > 1);
      if (next && t.length && Number(t[0].prix) > 0) {
        const pct = Math.round((1 - Number(next.prix) / Number(t[0].prix)) * 100);
        txt += ` · ${tenueName()} : −${pct} % dès ${next.min} pièces`;
      }
      totalEl.textContent = txt;
    }
  };

  const render = () => {
    const s = G.state;
    const t = tenue();
    // Après l'envoi, les tuiles ne sont plus là : l'aperçu garde la dernière tenue choisie.
    const wanted = t ? t.value : (sets.some((x) => x.dataset.adcHeroSet === s.tenue) ? s.tenue : '');
    if (wanted) sets.forEach((x) => { x.hidden = x.dataset.adcHeroSet !== wanted; });
    const shown = sets.find((x) => !x.hidden) || null;
    const short = shown ? shown.dataset.adcHeroSet : '';
    const placementLabel = t ? t.dataset.placementLabel : '';
    // L'emplacement n'est rempli qu'ici : sans script, aucun emplacement n'est transmis plutôt qu'un faux.
    if (placement && t) placement.value = t.dataset.placement;
    if (count) count.textContent = `${s.name.length}/${G.cfg.max}`;

    const ok = allowed();
    colorBtns.forEach((b) => {
      b.disabled = !ok.includes(b);
      b.setAttribute('aria-pressed', String(b.dataset.adcHeroColor === s.colorName));
    });
    threadBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.adcHeroThread === s.threadName)));
    const cn = root.querySelector('[data-adc-hero-color-name]');
    if (cn && s.colorName) cn.textContent = s.colorName;
    const tn = root.querySelector('[data-adc-hero-thread-name]');
    if (tn && s.threadName) tn.textContent = s.threadName;

    if (caption) {
      const bits = [short];
      if (s.colorName) bits.push(s.colorName.toLowerCase());
      if (!s.logo && s.threadName) bits.push('fil ' + s.threadName.toLowerCase());
      if (placementLabel) bits.push(placementLabel);
      caption.textContent = bits.filter(Boolean).join(' · ');
    }
    if (fromLink) fromLink.hidden = !(G.fromLink() && s.name);
    if (shown) {
      // Le nom saisi n'est pas recopié dans l'attribut : il resterait lisible dans les enregistrements de session.
      const what = s.logo ? 'logo joint' : (s.name ? 'votre nom brodé' : `nom ${G.PLACEHOLDER}`);
      shown.querySelectorAll('.adc-preview__main svg').forEach((svg) => {
        svg.setAttribute('aria-label', ['Aperçu : ' + short, what, placementLabel].filter(Boolean).join(', '));
      });
    }
    renderOrder();
  };

  if (input) input.addEventListener('input', () => {
    if (!tracked && G.state.name) { tracked = true; track('nom_saisi_accueil'); }
  });
  tenues.forEach((r) => r.addEventListener('change', () => {
    // Un coloris absent de la nouvelle tenue est remplacé par le premier proposé.
    const ok = allowed();
    const patch = { tenue: r.value };
    if (ok.length && !ok.some((b) => b.dataset.adcHeroColor === G.state.colorName)) {
      patch.colorName = ok[0].dataset.adcHeroColor;
      patch.colorHex = ok[0].dataset.hex;
    }
    if (orderErr) orderErr.textContent = '';
    G.setStyle(patch);
    trackChange('tenue');
    track('tenue_choisie', { tenue: r.value }, r.value);
  }));
  colorBtns.forEach((b) => b.addEventListener('click', () => {
    G.setStyle({ colorName: b.dataset.adcHeroColor, colorHex: b.dataset.hex });
    trackChange('coloris');
  }));
  threadBtns.forEach((b) => b.addEventListener('click', () => {
    G.setStyle({ threadName: b.dataset.adcHeroThread, threadHex: b.dataset.hex });
    trackChange('fil');
  }));
  document.addEventListener('adc:nom', render);
  document.addEventListener('adc:style', render);
  document.addEventListener('adc:logo', render);

  // Glisser-déposer du logo sur la zone prévue.
  const drop = root.querySelector('[data-adc-logo-drop]');
  const fileInput = root.querySelector('[data-adc-logo-input]');
  if (drop && fileInput && typeof DataTransfer === 'function') {
    ['dragenter', 'dragover'].forEach((type) => drop.addEventListener(type, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'dragend', 'drop'].forEach((type) => drop.addEventListener(type, () => drop.classList.remove('is-over')));
    drop.addEventListener('drop', (e) => {
      e.preventDefault();
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!f) return;
      const dt = new DataTransfer();
      dt.items.add(f);
      fileInput.files = dt.files;
      fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  if (qtyWrap) {
    qtyWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-inc],[data-dec]');
      if (!btn || btn.disabled) return;
      const size = btn.closest('.adc-qty').dataset.size;
      qty[size] = Math.max(0, Math.min(999, (qty[size] || 0) + (btn.hasAttribute('data-inc') ? 1 : -1)));
      saveSel();
      if (orderErr) orderErr.textContent = '';
      trackChange('quantites');
      renderOrder();
    });
    qtyWrap.addEventListener('change', (e) => {
      const inp = e.target.closest('[data-qty]');
      if (!inp) return;
      const n = parseInt(inp.value, 10);
      qty[inp.closest('.adc-qty').dataset.size] = Number.isFinite(n) ? Math.max(0, Math.min(999, n)) : 0;
      saveSel();
      renderOrder();
    });
  }
  if (recap) recap.addEventListener('click', (e) => {
    const edit = e.target.closest('[data-adc-recap-edit]');
    const rm = e.target.closest('[data-adc-recap-remove]');
    if (rm) {
      delete sel[rm.dataset.adcRecapRemove];
      saveSel();
      builtFor = '';
      renderOrder();
      if (orderBtn) orderBtn.focus();
      return;
    }
    if (!edit) return;
    const [t, c] = splitKey(edit.dataset.adcRecapEdit);
    const radio = tenues.find((r) => r.value === t);
    if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    const cb = colorBtns.find((b) => b.dataset.adcHeroColor === c);
    if (cb) G.setStyle({ colorName: c, colorHex: cb.dataset.hex });
    const firstInput = qtyWrap && qtyWrap.querySelector('[data-qty]:not([disabled])');
    if (firstInput) firstInput.focus();
  });
  if (toggle) toggle.addEventListener('click', () => {
    maquetteOpen = !maquetteOpen;
    renderOrder();
    if (maquetteOpen) {
      const mail = maquette && maquette.querySelector('input[type="email"]');
      if (mail) mail.focus();
      track('cta_clic', { emplacement: 'composeur', chemin: 'visuel' }, 'composeur_visuel');
    }
  });

  const setLogoButtons = (off) => {
    root.querySelectorAll('[data-adc-logo-pick], [data-adc-logo-clear]').forEach((b) => { b.disabled = off; });
  };
  const known = (m) => Object.assign(new Error(m), { adc: true });
  const readJson = (r) => r.json().catch(() => ({}));
  const submitOrder = async () => {
    if (busy) return;
    const p = current();
    if (!p || !p.orderable) return;
    if (orderErr) orderErr.textContent = '';
    const s = G.state;
    // Logo figé au moment du clic : un retrait ou un changement pendant l'envoi ne mélange pas les fichiers.
    const lg = s.logo;
    const fail = (msg, field, focusEl) => {
      if (orderErr) orderErr.textContent = msg;
      track('ajout_bloque', { produit: p.handle, champ: field }, field);
      if (focusEl) focusEl.focus();
    };
    if (!lg && !(s.name || '').trim()) {
      fail('Déposez votre logo, ou indiquez le nom de l’entreprise à broder.', 'broderie', root.querySelector('[data-adc-logo-pick]:not([hidden])') || input);
      return;
    }
    const groups = selection();
    if (!groups.length) {
      fail('Ajoutez au moins une pièce.', 'qty', qtyWrap && qtyWrap.querySelector('.adc-qty:not(.is-unavailable) [data-inc]'));
      return;
    }
    const base = {};
    if (!lg) {
      base['Nom brodé'] = s.name.trim();
    }
    // Une configuration par tenue et par coloris : le panier les présente en cartes séparées.
    const stamp = Date.now().toString(36).toUpperCase();
    const lines = [];
    groups.forEach((g, i) => {
      const props = Object.assign({}, base, { Emplacement: g.p.place, _Configuration: `ADC-${stamp}-${i + 1}${Math.random().toString(36).slice(2, 5).toUpperCase()}` });
      g.lines.forEach((l) => lines.push(Object.assign({}, l, { props, handle: g.p.handle })));
    });
    const addUrl = `${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`;
    const changeUrl = `${(window.routes && window.routes.cart_change_url) || '/cart/change'}.js`;
    busy = true;
    setLogoButtons(true);
    if (orderBtn) orderBtn.setAttribute('aria-disabled', 'true');
    if (orderLabel) orderLabel.textContent = 'Ajout en cours…';
    let added = null;
    try {
      let rest = lines;
      if (lg) {
        // 1re ligne en multipart avec le fichier ; les suivantes reprennent l'adresse du fichier téléversé.
        const first = lines[0];
        const fd = new FormData();
        fd.append('id', first.v.id);
        fd.append('quantity', first.q);
        Object.entries(first.props).forEach(([k, v]) => fd.append(`properties[${k}]`, v));
        fd.append('properties[_Fichier logo]', lg.name);
        fd.append('properties[Logo]', lg.file, lg.name);
        const r1 = await fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const j1 = await readJson(r1);
        if (!r1.ok) throw known(j1.description || j1.message || 'Ajout impossible.');
        added = j1.items ? j1.items[0] : j1;
        const url = added && added.properties ? added.properties.Logo : '';
        if (!url) throw known('Le logo n’a pas pu être joint. Réessayez, ou contactez-nous.');
        lines.forEach((l) => { l.props.Logo = url; l.props['_Fichier logo'] = lg.name; });
        rest = lines.slice(1);
      }
      if (rest.length) {
        const r2 = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: rest.map((l) => ({ id: l.v.id, quantity: l.q, properties: l.props })) }),
        });
        const j2 = await readJson(r2);
        if (!r2.ok) throw known(j2.description || j2.message || 'Ajout impossible.');
      }
      track('ajout_panier', { produit: groups.map((g) => g.p.handle).join(','), tenues: groups.length, pieces: lines.reduce((a, l) => a + l.q, 0), lignes: lines.length, mode: lg ? 'logo' : 'text' }, groups.length > 1 ? 'plusieurs' : groups[0].p.handle);
      // Tout est au panier : la sélection repart de zéro.
      sel = {};
      saveSel();
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      if (root.dataset.adcAfterAdd === 'cart') {
        if (orderLabel) orderLabel.textContent = 'Ajouté, ouverture du panier…';
        window.location.href = cartUrl;
        return;
      }
      // Rester sur la fiche : compteur du panier à jour, confirmation avec accès au panier.
      const pieces = lines.reduce((a, l) => a + l.q, 0);
      try {
        const cart = await (await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })).json();
        document.querySelectorAll('.adc-cart-link__count').forEach((el) => { el.textContent = cart.item_count; });
        document.querySelectorAll('.adc-cart-link--desktop').forEach((el) => el.classList.remove('adc-cart-link--desktop'));
        document.querySelectorAll('.adc-header__mobile-cta').forEach((el) => { el.hidden = true; });
      } catch (e) {}
      const done = root.querySelector('[data-adc-added]');
      if (done) {
        const txt = done.querySelector('[data-adc-added-text]');
        if (txt) txt.textContent = `${pieces} pièce${pieces > 1 ? 's' : ''} ajoutée${pieces > 1 ? 's' : ''} au panier.`;
        done.hidden = false;
        done.focus();
      }
      qty = {};
      builtFor = '';
      busy = false;
      setLogoButtons(false);
      if (orderBtn) orderBtn.removeAttribute('aria-disabled');
      if (orderLabel) orderLabel.textContent = orderText;
      renderOrder();
    } catch (err) {
      // La ligne déjà ajoutée avec le logo est retirée : pas de pièce en double au nouvel essai.
      if (added && added.key) {
        try {
          await fetch(changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: added.key, quantity: 0 }) });
        } catch (e) {}
      }
      if (orderErr) orderErr.textContent = err && err.adc ? `${err.message} Vérifiez votre panier.` : 'Connexion interrompue. Vérifiez votre panier, puis réessayez.';
      track('ajout_bloque', { produit: p.handle, champ: 'submit' }, 'submit');
      if (orderLabel) orderLabel.textContent = orderText;
      if (orderBtn) orderBtn.removeAttribute('aria-disabled');
      setLogoButtons(false);
      busy = false;
    }
  };
  if (orderBtn) orderBtn.addEventListener('click', submitOrder);

  // Retour arrière depuis le panier : bouton rétabli, quantités remises à zéro (ces pièces sont déjà au panier).
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    busy = false;
    setLogoButtons(false);
    if (orderBtn) orderBtn.removeAttribute('aria-disabled');
    if (orderLabel) orderLabel.textContent = orderText;
    if (orderErr) orderErr.textContent = '';
    sel = loadSel();
    builtFor = '';
    renderOrder();
  });

  // La tenue, le coloris et le fil affichés (par défaut ou repris de la visite) sont publiés : la demande
  // transmet exactement ce que montre l'aperçu.
  const stored = tenues.find((r) => r.value === G.state.tenue);
  if (stored) stored.checked = true;
  const cur = tenue();
  const ok0 = allowed();
  const c0 = ok0.find((b) => b.dataset.adcHeroColor === G.state.colorName) || ok0[0] || null;
  const t0 = threadBtns.find((b) => b.dataset.adcHeroThread === G.state.threadName) || threadBtns[0] || null;
  G.setStyle({
    tenue: cur ? cur.value : null,
    colorName: c0 ? c0.dataset.adcHeroColor : null, colorHex: c0 ? c0.dataset.hex : '',
    // Sans choix du fil (couleur fixée sur la maquette), l'aperçu prend une couleur lisible sur le tissu.
    threadName: t0 ? t0.dataset.adcHeroThread : '', threadHex: t0 ? t0.dataset.hex : '',
  });
  render();

  // Retour d'envoi : la confirmation (ou l'alerte) reçoit le focus, sans déplacer la page.
  const back = root.querySelector('.adc-herolive__done, .adc-status--error');
  if (back) { back.tabIndex = -1; back.focus({ preventScroll: true }); }
})();
